import router from '@/router';
import { useAuthStore } from '@/stores/auth';

// 幂等标志：并发的多个请求同时 401 时只跳一次登录，避免连环跳转/刷新。
let handling = false;

/**
 * 统一处理 401（登录态失效）。
 *
 * 取代此前各 axios 实例各自 `localStorage.removeItem` + `location.href='/login'` 的做法：
 * - 走 pinia 清登录态（响应式，侧边栏/守卫立即感知），不再手抠 localStorage；
 * - 用 router 做 **SPA 跳转**，不整页硬刷新（保留应用状态、体验平滑）；
 * - 幂等，避免多请求并发 401 时反复跳转（就是之前「时不时刷新」的隐患版）。
 *
 * mall(8095) 与 admin(8090) 复用同一把 admin token，故任一实例 401 都走这里统一处理，
 * 不再由 mall 单方面清掉共享 token。
 */
export function handleUnauthorized(): void {
  if (handling) return;
  handling = true;

  try {
    useAuthStore().clearSession();
  } catch {
    // pinia 尚未就绪的极端场景兜底
    localStorage.removeItem('lulupaw_admin_token');
  }

  const current = router.currentRoute.value;
  if (current.path !== '/login') {
    void router
      .replace({ path: '/login', query: { redirect: current.fullPath } })
      .catch(() => {})
      .finally(() => {
        handling = false;
      });
  } else {
    handling = false;
  }
}
